module.exports = __webpack_public_path__ + "img/img_fangquan.eca8d7b5.png";